// extracted by mini-css-extract-plugin
export default {"base":"ModalPopup_base__LrFpX","card":"ModalPopup_card__KcLeA"};